import { DeviceFirmwareUpdateApi } from '@/../generated-client/apis/DeviceFirmwareUpdateApi';
import { FirmwareLookupTableApi } from '@/../generated-client/apis/FirmwareLookupTableApi';
import { useApiStore } from '@/stores/apiStore';
import { FirmwareLookupTableUpdate } from '../../generated-client/models';

let deviceFirmwareUpdateApi: DeviceFirmwareUpdateApi | null = null;
let firmwareLookupTableApi: FirmwareLookupTableApi | null = null;
let lastConfig: unknown = null;

function getDeviceFirmwareUpdateApi(): DeviceFirmwareUpdateApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (deviceFirmwareUpdateApi === null || lastConfig !== apiConfig) {
    deviceFirmwareUpdateApi = new DeviceFirmwareUpdateApi(apiConfig);
    lastConfig = apiConfig;
  }

  return deviceFirmwareUpdateApi;
}

function getFirmwareLookupTableApi(): FirmwareLookupTableApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (firmwareLookupTableApi === null || lastConfig !== apiConfig) {
    firmwareLookupTableApi = new FirmwareLookupTableApi(apiConfig);
    lastConfig = apiConfig;
  }

  return firmwareLookupTableApi;
}

export const getDFUInformation = async () => {
  const api = getFirmwareLookupTableApi();
  return await api.apiFirmwareLookupTableGetGet();
};

export const getDFUFileNames = async () => {
  const api = getDeviceFirmwareUpdateApi();
  return await api.apiDeviceFirmwareUpdateGetListGet();
};

export const updateAppVersionData = async (
  appVersionData: FirmwareLookupTableUpdate,
) => {
  const api = getFirmwareLookupTableApi();
  return await api.apiFirmwareLookupTableUpdatePut({
    firmwareLookupTableUpdate: appVersionData,
  });
};

export const setAsNewest = async (fileName: string) => {
  const api = getDeviceFirmwareUpdateApi();
  return await api.apiDeviceFirmwareUpdateSetAsNewestPut({
    deviceFirmwareUpdateSetAsNewest: { blob_name: fileName },
  });
};

export const addDFUFile = async (file: File) => {
  const api = getDeviceFirmwareUpdateApi();

  return await api.apiDeviceFirmwareUpdateAddPost({
    file,
  });
};

const base64ToUint8Array = (base64: string) => {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const downloadBlob = async (fileName: string) => {
  try {
    const api = getDeviceFirmwareUpdateApi();
    const response = await api.apiDeviceFirmwareUpdateDownloadGet({
      blobName: fileName,
    });

    const base64String = response; // Assuming the result is the Base64 string itself
    const binaryData = base64ToUint8Array(base64String);
    const blob = new Blob([binaryData], { type: 'application/zip' });
    const blobURL = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = blobURL;
    a.download = `${fileName}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobURL);
    return response;
  } catch (error) {
    // console.log(error);
  }
};

export const deleteBlob = async (fileName: string) => {
  const api = getDeviceFirmwareUpdateApi();

  return await api.apiDeviceFirmwareUpdateDeleteDelete({
    deviceFirmwareUpdateDelete: { blob_name: fileName },
  });
};
